import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { userVids } from "@extensions/enums";
import { useEffect, useState } from "react";
import { Button, Form, Input, Select, Space, message } from "antd";
import { serverFetch } from "@server";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";

const CompanyUser = ({ itemDefault, onClose }) => {
  const [item, setItem] = useState({ ...itemDefault });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const viewport = useViewportBreakpoint();
  const isMobile = viewport === "mobile";

  useEffect(() => form.setFieldsValue(item), []);

  const onValuesChange = value => setItem({ ...item, ...value });

  const onSave = () => {
    setLoading(true);
    serverFetch("user", { method: "POST", bodyData: item })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCancel = () => onClose(false);

  const formProps = isMobile
    ? { layout: "vertical", colon: false, disabled: loading, style: { width: "100%", maxWidth: "100%" } }
    : { labelCol: { span: 8 }, wrapperCol: { span: 24 }, colon: false, disabled: loading, style: { maxWidth: 800 } };

  const formFields = (
    <>
      <Form.Item label="Наименование" name="name">
        <Input />
      </Form.Item>
      <Form.Item label="Вид" name="vid">
        <Select options={userVids} />
      </Form.Item>
      {!isMobile && (
        <Form.Item label=" ">
          <Space>
            <Button className="misoft-btn" onClick={onSave}>
              Сохранить
            </Button>
            <Button className="misoft-btn" onClick={onCancel}>
              Отмена
            </Button>
          </Space>
        </Form.Item>
      )}
    </>
  );

  return (
    <div>
      <div
        className={`misoft-modal-overlay${isMobile ? " company-base-overlay--mobile" : ""}`}
        onClick={e => e.target === e.currentTarget && onClose(false)}
      >
        <div
          className={`misoft-modal-content${isMobile ? " company-base-sheet--mobile" : ""}`}
          style={isMobile ? undefined : { width: 800 }}
          onClick={e => e.stopPropagation()}
        >
          {isMobile ? (
            <>
              <div className="company-base-sheet-header">
                <span className="company-base-sheet-title">Пользователь</span>
                <Space size="small" className="company-base-sheet-actions">
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={onSave}
                    loading={loading}
                    aria-label="Сохранить"
                    className="company-base-header-icon-btn"
                  />
                  <Button
                    type="default"
                    icon={<CloseOutlined />}
                    onClick={() => onClose(false)}
                    aria-label="Закрыть"
                    className="company-base-header-icon-btn"
                  />
                </Space>
              </div>
              <div className="company-base-sheet-body">
                <Form form={form} onValuesChange={onValuesChange} {...formProps}>
                  {formFields}
                </Form>
              </div>
            </>
          ) : (
            <>
              <div className="misoft-modal-title">
                <span>Пользователь</span>
                <CloseOutlined
                  className="misoft-section-title-close"
                  onClick={() => onClose(false)}
                  style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
                />
              </div>
              <Form form={form} onValuesChange={onValuesChange} {...formProps}>
                {formFields}
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyUser;
